var map = {
	"./arrow.svg": 1769,
	"./business.png": 6424,
	"./icon_agreg_sucur_act.png": 6360,
	"./icon_menu_cerrar_act.png": 1920,
	"./icon_menu_graf_indicad_act.png": 6510,
	"./icon_menu_list_planes_act.png": 1361,
	"./icon_menu_listado_negocios_act.png": 3227,
	"./icon_menu_manuales-act.png": 5237,
	"./icon_menu_manuales_inact.png": 556,
	"./icon_menu_neg_vencidos_act.png": 1119,
	"./icon_menu_notific_act.png": 2753,
	"./icon_menu_pago_negocio_act.png": 7148,
	"./icon_menu_report_nego_act.png": 6179,
	"./icono_menu_desplegable_act.png": 3946,
	"./icono_menu_desplegable_inact.png": 421,
	"./suppliers.png": 7451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9540;